<style>
</style>
<template>
<v-row dense>
  <v-col cols="12">
    <setting-value
        name="fullName"
        v-model="value.addressName"
        :required="required"
        :counter="64"
    ></setting-value>
  </v-col>
  <v-col cols="9">
    <setting-value
        name="street"
        v-model="value.street"
        :required="required"
        :counter="30"
    ></setting-value>
  </v-col>
  <v-col cols="3">
    <setting-value
        name="streetNo"
        v-model="value.streetNo"
        :required="required"
        :counter="8"
    ></setting-value>
  </v-col>
  <v-col cols="4">
    <setting-value
        name="zipCode"
        v-model="value.zipCode"
        :required="required"
        :counter="6"
    ></setting-value>
  </v-col>
  <v-col cols="8">
    <setting-value
        name="postSite"
        v-model="value.postSite"
        :required="required"
        :counter="25"
    ></setting-value>
  </v-col>
  <v-col cols="12">
    <select-country
        name="countryCode"
        label="countryCode"
        v-model="value.country"
        :required="required"
    ></select-country>
  </v-col>
</v-row>
</template>
<script>
import TransformMixin from '../mixins/transform-mixin.js'
import SettingValue from '../components/setting-value.vue'
import SelectCountry from '../components/select-country.vue'
export default {
  name: 'setting-address',
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    defaultValue: {
      type: Object,
      default () {
        return {}
      }
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'setting-value': SettingValue,
    'select-country': SelectCountry
  },
  mixins: [TransformMixin],
  // data() {
  //   return {
  //     inputValue: this.value != null && this.value.addressName != null ? { ...this.value } : { ...this.defaultValue }
  //   }
  // },
  // computed: {
  //   inputValue: {
  //     get() {
  //       return this.value ? this.value : this.defaultValue
  //     }
  //   }
  // },
  // methods: {
  //   getInput() {
  //     this.$emit('input', this.inputValue)
  //   }
  // }
}
</script>
